<template>
  <svg
    version="1.1"
    id="svg2385"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 450.2 478.3"
    style="enable-background:new 0 0 450.2 478.3;"
    xml:space="preserve"
  >
    <g id="layer1" transform="translate(-236.97 -366.48)">
      <radialGradient
        id="path3382_1_"
        cx="634.4189"
        cy="565.0641"
        r="245.83"
        gradientTransform="matrix(0.8383 0 0 -0.8383 -54.3704 1036.0054)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" style="stop-color:#6A6A6A" />
        <stop offset="1" style="stop-color:#000000" />
      </radialGradient>
      <path
        id="path3382"
        class="st0"
        d="M687.1,609.6c0,124.3-100.8,225.1-225.1,225.1C337.8,834.7,237,733.8,237,609.6
		c0-124.2,100.8-225.1,225.1-225.1C586.3,384.5,687.1,485.3,687.1,609.6L687.1,609.6z"
      />

      <radialGradient
        :id="idGradient"
        cx="548.4"
        cy="-234.391"
        r="225.06"
        gradientTransform="matrix(1 0 0 -1.0001 -69.79 333.8919)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" :style="{ 'stop-color': color }" />
        <stop offset="0.4702" :style="{ 'stop-color': color }" />
        <stop offset="1" :style="{ 'stop-color': color, 'stop-opacity': 0.3 }" />
      </radialGradient>
      <path
        id="path3400"
        :class="st"
        d="M462,384.5c-49.1,0-94.6,15.8-131.6,42.5c-16.1,19.5-27.4,39-27.4,39l-20.6,7.9
		c-28.6,37.7-45.5,84.8-45.5,135.7c0,4.8,0.1,9.5,0.4,14.2c5.1,9.1,8.9,15,8.9,15l-2.6,25.7c14.7,58.7,52.5,108.2,103.1,138.5
		c3.6,2.3,6.6,3.8,10,5.6c-1.8-1.7-2.3-2.1-3.5-3.2c-13.3-13.7-24.4-29.7-24.4-29.7l32-29.5c0,0,20.6,15.6,43.7,23.6
		c23.1,8.1,48.8,8.6,48.8,8.6l15.9,40.8c0,0-14,7.2-33.9,10.7c-3.6,0.6-7.3,1.1-11.1,1.6c12.3,2.1,24.9,3.2,37.8,3.2
		c52,0,100-17.7,138.1-47.4c11.9-16,19.8-29.7,19.8-29.7l17.4-6.8c30.8-38.2,49.4-86.7,49.8-139.5c-6.1-18.2-12.8-28.8-12.8-28.8
		s1.7-16.6-0.7-34.8c-0.4-2.9,1.5-1.8,3.9-3.4c-0.7-2.6-3.2-10.3-4.5-14c-5-14.5-9.8-21.4-13-27.8c6.2,3.5,0,0,0,0
		C621.8,432.1,547.5,384.5,462,384.5L462,384.5z M489.3,393c18.7,0.3,38.2,6.3,38.2,6.3s22.2,8.5,38,20.6
		c15.8,12,25.3,27.6,25.3,27.6l-40.3,27.8c0,0-21.7-14.9-44.3-22.9c-22.6-8-46.3-9.1-46.3-9.1l-11.4-41.5c0,0,17.3-8.1,37-8.7
		C486.8,393,488,393,489.3,393z M357.7,504.2c13.8,0.1,25.3,1.7,25.3,1.7l20.8,88.4L337,658c0,0-20.9-13.2-35.9-26.2
		c-15-13-24.3-25.6-24.3-25.6s2.7-25.7,8.8-47.7c6.1-22.1,15.7-40.5,15.7-40.5s16.5-9.5,36.9-12.5
		C344.7,504.5,351.4,504.2,357.7,504.2L357.7,504.2z M574.3,567.4c0,0,18.8,8.3,34,20.4c15.2,12.2,26.8,28.2,26.8,28.2
		s-1.1,22-8.3,44.9c-7.3,22.9-20.7,46.6-20.7,46.6s-18.8,6.9-38.6,8.8c-19.8,1.9-40.7-1.3-40.7-1.3l-10.3-43.3l-10.7-44.5
		c0,0,14.1-17,31.3-32S574.3,567.4,574.3,567.4z"
      />

      <linearGradient
        id="path3514_1_"
        gradientUnits="userSpaceOnUse"
        x1="596.1016"
        y1="-315.9783"
        x2="713.7116"
        y2="-337.8783"
        gradientTransform="matrix(0.9741 0 0 -0.9741 -62.0851 327.3514)"
      >
        <stop offset="0" style="stop-color:#000000" />
        <stop offset="1" style="stop-color:#000000;stop-opacity:0" />
      </linearGradient>
      <path
        id="path3514"
        class="st2"
        d="M633.4,616.7c0,0-1,21.4-8.1,43.7s-20.2,45.4-20.2,45.4s-18.3,6.7-37.6,8.5
		c-19.3,1.8-39.6-1.3-39.6-1.3l-10.1-42.2l-10.4-43.3c0,0,13.8-16.6,30.5-31.2c16.7-14.6,36.3-27,36.3-27s18.3,8.1,33.2,19.9
		C622.1,601.1,633.4,616.7,633.4,616.7z"
      />

      <linearGradient
        id="path3516_1_"
        gradientUnits="userSpaceOnUse"
        x1="474.3954"
        y1="-276.598"
        x2="362.5253"
        y2="-232.698"
        gradientTransform="matrix(0.9748 0 0 -0.9748 -68.0912 325.9843)"
      >
        <stop offset="0" style="stop-color:#000000" />
        <stop offset="1" style="stop-color:#000000;stop-opacity:0" />
      </linearGradient>
      <path
        id="path3516"
        class="st3"
        d="M337.1,656.1c0,0-20.3-12.9-35-25.5c-14.7-12.6-23.6-25-23.6-25s2.6-25,8.6-46.5
		c6-21.5,15.3-39.5,15.3-39.5s16.1-9.3,36-12.2c19.9-2.9,43.6,0.5,43.6,0.5l20.3,86.2L337.1,656.1z"
      />

      <linearGradient
        id="path3518_1_"
        gradientUnits="userSpaceOnUse"
        x1="630.8148"
        y1="-175.4575"
        x2="652.1248"
        y2="-105.1275"
        gradientTransform="matrix(0.8784 0 0 -0.8784 -39.7857 278.0769)"
      >
        <stop offset="0" style="stop-color:#333333" />
        <stop offset="1" style="stop-color:#000000;stop-opacity:0" />
      </linearGradient>
      <path
        id="path3518"
        class="st4"
        d="M526.5,403.6c0,0,19.5,7.5,33.4,18.1c13.9,10.6,22.2,24.2,22.2,24.2l-35.4,24.4
		c0,0-19-13-38.9-20.1s-47.7-9.8-47.7-9.8l-9.3-36.8c0,0,19.4-6.8,36.7-7.3C504.9,395.8,526.5,403.6,526.5,403.6L526.5,403.6z"
      />
      <path id="path3479" class="st5" d="M382,507.1c0,0,36.2-48.1,78.4-64.3" />
      <path id="path3506" class="st6" d="M552.8,474.1c0,0,27,42.9,23.5,91.9" />
      <path id="path3481" class="st5" d="M550.4,474.6c0,0,27.6,44.4,24.1,93.4" />
      <path id="path3483" class="st5" d="M587.8,447.3c0,0,59.8,23.6,86,98.3" />
      <path id="path3485" class="st5" d="M635.4,615.9c0,0,21-1.6,39.4-32.8" />
      <path id="path3487" class="st5" d="M620.4,757.3c0,0,2.9-18.1-14.5-51" />
      <path id="path3489" class="st5" d="M453.7,778.9c0,0,32.4-8.6,73.4-65.1" />
      <path id="path3491" class="st5" d="M336.8,657.2c0,0-2,50.4,23.2,90" />
      <path id="path3493" class="st5" d="M328.9,775.9c0,0-7.4,0.1-35.5-16.8" />
      <path id="path3495" class="st5" d="M277.3,606.1c0,0-20.1,8.5-31,31.9" />
      <path id="path3497" class="st5" d="M302.7,466.3c0,0-7.2,27.9-1,51.4" />
      <path id="path3499" class="st5" d="M326.9,430.6c0,0,60-50.9,121.2-28.3" />
      <path id="path3501" class="st5" d="M469.1,819.2c0,0,52.4,13.5,133.2-34.2" />
      <path id="path3504" class="st7" d="M382.2,503.5c0,0,30.1-41.5,74.3-61.3" />
      <path id="path3508" class="st8" d="M454.5,780.7c0,0,30.8-6,71.8-62.5" />
      <path id="path3510" class="st8" d="M334.8,658.3c0,0-1.9,50.4,23.2,90" />
      <path id="path2453" class="st9" d="M404.4,594.6c0,0,26.3,6.2,101.3,32.7" />
      <path id="path3260" class="st10" d="M404.4,593.3c0,0,26.3,6.2,101.3,32.7" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconBall',
  props: {
    color: {
      type: String,
      required: true,
    },
    st: {
      type: String,
      required: true,
    },
  },
  computed: {
    idGradient() {
      let gradientId;
      switch (this.st) {
        case 'st1g':
          gradientId = 'green';
          break;
        case 'st1y':
          gradientId = 'yellow';
          break;
        case 'st1r':
          gradientId = 'red';
          break;
        case 'st1b':
          gradientId = 'blue';
          break;
      }
      return gradientId;
    },
  },
};
</script>

<style scoped>
.st0 {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: url(#path3382_1_);
}
.st1r {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: url(#red);
}
.st1g {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: url(#green);
}
.st1b {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: url(#blue);
}
.st1y {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: url(#yellow);
}
.st2 {
  fill: none;
  stroke: url(#path3514_1_);
  stroke-width: 4.8705;
  stroke-linejoin: round;
}
.st3 {
  fill: none;
  stroke: url(#path3516_1_);
  stroke-width: 4.874;
  stroke-linejoin: round;
}
.st4 {
  fill: none;
  stroke: url(#path3518_1_);
  stroke-width: 5.0158;
}
.st5 {
  fill: none;
  stroke: #666666;
}
.st6 {
  fill: none;
  stroke: #ececec;
  stroke-width: 3;
}
.st7 {
  fill: none;
  stroke: #f2f2f2;
  stroke-width: 3;
  stroke-linecap: square;
}
.st8 {
  fill: none;
  stroke: #ffffff;
  stroke-width: 3;
}
.st9 {
  fill: none;
  stroke: #999999;
}
.st10 {
  fill: none;
  stroke: #ececec;
}
</style>
